import Cookies from 'js-cookie'
import {getStore, setStore} from '@/utils/store'

const TokenKey = 'access_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

/**
 * 登录角色
 * @returns {*}
 */
export function getRoles() {
  return Cookies.get('roles') || getStore({name: 'roles'})
}

export function setRoles(roles) {
  setStore({
    name: 'roles',
    content: roles
  })
  return Cookies.set('roles', roles)
}

/**
 * 租户别名
 * @returns {*}
 */
export function getNameCode() {
  return Cookies.get('nameCode') || getStore({name: 'nameCode'}) || 'unknown'
}

export function setNameCode(nameCode) {
  setStore({
    name: 'nameCode',
    content: nameCode
  })
  return Cookies.set('nameCode', nameCode)
}



// WEBPACK FOOTER //
// ./src/utils/cookie/index.js